import React from "react";
import { Navigate, Route, Routes as Switch } from "react-router-dom";
import AccountManagement from "./views/pages/account-management/account-management";
import User from "./views/pages/user/user";

export const Routes = () => {
   return (
      <Switch>
         <Route path="/*" element={<AccountManagement />} />
         <Route path="/user/*" element={<User />} />
         <Route path="*" element={<Navigate to="/login" />} />
      </Switch>
   );
};
